import createLeftComponent from "../../../../helpers/common/CoreInputText/components/Left/fabric";
import { SEARCH_DISPLAY_NAME } from "../../utils/core";

export const Component = createLeftComponent(SEARCH_DISPLAY_NAME);
export default Component;
